import { observer } from 'mobx-react';
import { useCallback, useMemo } from 'react';
import { BALANCE_TYPE, BALANCE_TYPE_TXT, balanceTypeFilterOptions } from '../../constants/walletTransactionRow';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import walletTransactionStore from 'src/view/screens/WalletTransactionLogScreen/screens/WTLogScreen/store/walletTransactionStore';
import { LoadingStatus } from '~/types/main';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { getLastArrayItem } from '~/utils/helpers';
import { reportsStore } from '~/view/screens/ReportsScreen/store/reportsStore';
import ReportsCalendar from '~/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';

const WTLogHeader = (): JSX.Element => {
  // --------------- Handlers ---------------
  const onSelectBalanceType = useCallback((options: IPickerOption[]) => {
    const { value } = getLastArrayItem<IPickerOption>(options) || {};
    walletTransactionStore.setFilters({ balance_type: value as BALANCE_TYPE });
  }, []);

  const onSelectDate = () => {
    walletTransactionStore.setFilters({ startDate: reportsStore.filters.startDate, endDate: reportsStore.filters.endDate });
  };

  // --------------- Other ---------------
  const selectedPickerOption = useMemo(() => {
    const { balance_type } = walletTransactionStore.filters;
    const trans = balance_type ? localeStore.t(BALANCE_TYPE_TXT[balance_type]) : 'no_balance_type';

    return balance_type ? [{ label: trans, value: balance_type }] : [];
  }, [walletTransactionStore.filters.balance_type]);

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row">
        <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} onSelectDate={onSelectDate} />
        <Picker
          options={balanceTypeFilterOptions}
          selectedOptions={selectedPickerOption}
          placeholder={localeStore.t('select_balance_type')}
          listClassName="wallet-transaction-header__filter"
          onSelect={onSelectBalanceType}
        />
      </div>
      <div className="d-flex gap-10">
        {walletTransactionStore.countLines > 0 ? (
          <Button
            title={localeStore.t('export_to_excel')}
            onClick={walletTransactionStore.downloadExportedDocument}
            loading={walletTransactionStore.exportLoadingStatus === LoadingStatus.Loading}
            appearance="secondary"
          />
        ) : null}
      </div>
    </div>
  );
};

export default observer(WTLogHeader);
